import React, { Component } from 'react';
import { PreMeetingScreen } from '../../../base/premeeting';
import { getLocalizedDateFormatter } from '../../../base/i18n';
import { getRoomName } from '../../../base/conference';
import { connect } from '../../../base/redux';
import { LobbyScreen, _connect } from './LobbyScreen';
import io from 'socket.io-client';
declare var interfaceConfig: Object;
window.socket = io(window.API_DOMAIN);
let interval;

function getTimeNow() {
    return getLocalizedDateFormatter().format('h:mm A | ddd, MMM D')
}
class RPC_LobbyScreen extends LobbyScreen {
    constructor(props) {
        super(props);
        this.state = {
            ...super.state,
            time: null
        }
        this._renderJoining = this._renderJoining.bind(this);
    }
    _renderJoining() {
        const { _error, _isAdminExist } = this.props;
        return (
            <div className="prejoin-input-area-container">
                <div className="prejoin-input-area">
                    {((!_error || _error.name != "conference.connectionError.accessDenied" ) && _isAdminExist) && <><div className="prejoin-error">You'll join the meeting as soon as the host accepts your request</div><div className="prejoin-preview-dropdown-container">
                        <div className="loader-a"></div>
                    </div></> }
                    {((!_error || _error.name != "conference.connectionError.accessDenied" ) && !_isAdminExist) && <div className="prejoin-error">There is no host in the meeting.</div> }
                    {_error && _error.name == "conference.connectionError.accessDenied" && <div className="prejoin-error">Your request to join the meeting has been denied by the admin.</div>}
                </div>
            </div>
        );
    }
    componentDidMount() {
        interval = setInterval(() => {
            this.setState({
                time: getTimeNow()
            })
            socket.emit('info', this.props.roomName);
        }, 1000);
        // super.componentDidMount ? super.componentDidMount() : null;
    }
    render() {
        const { time } = this.state;
        const {_knocking, _isAdminExist, _error } = this.props;
        return <div className="join-page">
            <div className="join-header">
                <div className="logo">
                    <img src={ interfaceConfig.DEFAULT_LOGO_URL } height="45"/>
                </div>
                <div className="time">{ time }</div>
                <div className="rp-menu">
                </div>
            </div>
            { super.render() }
        </div>
    }
}

function _mapStateToProps(state, ownProps) {
    
    const { error } = state['features/base/conference'];
    const { knocking } = state['features/lobby'];
    const { isAdminExist } = state['features/prejoin'];
    const roomName = getRoomName(state) 

    return {
        _knocking:knocking,
        _isAdminExist:isAdminExist,
        _error: error,
        roomName
    };
}

export default _connect(connect(_mapStateToProps)(RPC_LobbyScreen));